const COLOURS = [
  { bg: '#E6F1FB', color: '#185FA5' },
  { bg: '#EAF3DE', color: '#3B6D11' },
  { bg: '#EEEDFE', color: '#534AB7' },
  { bg: '#FCEBEB', color: '#A32D2D' },
  { bg: '#FDF0E8', color: '#993C1D' },
  { bg: '#E1F5EE', color: '#085041' },
];

const getColour = (name) => {
  if (!name) return COLOURS[0];
  const index = name.charCodeAt(0) % COLOURS.length;
  return COLOURS[index];
};

const getInitials = (name) => {
  if (!name) return '?';
  return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
};

const SIZES = {
  xs:  { width: 20, height: 20, fontSize: 8  },
  sm:  { width: 26, height: 26, fontSize: 9  },
  md:  { width: 32, height: 32, fontSize: 11 },
  lg:  { width: 40, height: 40, fontSize: 14 },
  xl:  { width: 56, height: 56, fontSize: 18 },
  '2xl': { width: 72, height: 72, fontSize: 24 },
};

export default function Avatar({ name, photoURL, size = 'md', onClick, style = {} }) {
  const sz = SIZES[size] || SIZES.md;
  const colours = getColour(name);

  return (
    <div
      onClick={onClick}
      style={{
        ...sz,
        borderRadius: '50%',
        background: photoURL ? 'transparent' : colours.bg,
        backgroundImage: photoURL ? `url(${photoURL})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colours.color,
        fontSize: sz.fontSize,
        fontWeight: 'var(--font-weight-normal)',
        flexShrink: 0,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
        ...style,
      }}
    >
      {!photoURL && getInitials(name)}
    </div>
  );
}